<script>
import TheFacultyStatisticsTable from "./TheFacultyStatisticsTable.vue";
import CardStatisticAttestation from "./CardStatisticAttestation.vue"
import TabsStatisticAttestation from "./TabsStatisticAttestation.vue";
import axios from "axios";
export default {
  name: "TheFacultyStatisticsCard",

  components: {
    TheFacultyStatisticsTable,
    CardStatisticAttestation,
    TabsStatisticAttestation,
  },

  props: {
    department: Number,
  },

  data() {
    return {
      facultyStatistics: {},
      tab: 0,
      loading: true,
    };
  },

  computed: {
    departmentName() {
      return this.facultyStatistics.meta.departmentName
    }
  },

  mounted() {
    this.getFacultyAttestationStatistics();
  },

  methods: {
    async getFacultyAttestationStatistics() {
      try {
        const response = await axios.get(`faculty_attestation_statistics/${this.department}`);
        this.facultyStatistics = response.data.facultyStatistics;
      } catch (err) {
        console.log(err);
      }
      this.loading = false;
    }
  },
}
</script>

<template>
  <card-statistic-attestation :loading="loading">
    <template #default>
      <v-card-title>
        {{departmentName}}
        {{facultyStatistics.meta.studyYearName}}
      </v-card-title>
      <tabs-statistic-attestation
        :date-attestations="facultyStatistics.dateAttestations"
        :addition-name-key="departmentName"
        v-slot="{dateAttestation}"
      >
        <v-sheet>
          <the-faculty-statistics-table
            style="min-width: 720px"
            :department-name="departmentName"
            :statistics="dateAttestation.statisticCourses"
          />
        </v-sheet>
      </tabs-statistic-attestation>
    </template>
  </card-statistic-attestation>
</template>

<style scoped>

</style>